import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';
import { Dimensions } from 'react-native';

// Obtenha a largura da tela
const { width } = Dimensions.get('window');

// 97% da largura da tela
const toastWidth = width * 0.97;

export const styles = StyleSheet.create({
  toast: {
    height: 55,
    width: toastWidth,
    backgroundColor: Colors.GreenPallete.greenOne,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    borderRadius: 4,
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 20,
    elevation: 10,
    transform: [{ translateX: (width - toastWidth) / 2 }] // Centraliza
  },
  error: {backgroundColor: Colors.RedPallete.red},
  check: {marginRight: 10},
  toastText: {
    fontSize: 10,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'white',
  },
});
